// extracted by mini-css-extract-plugin
module.exports = {"refuse":"refuse-2c6mw","dialog__deleteIcon":"dialog__deleteIcon-1faAp"};